import { makeStyles } from 'tss-react/mui';
import { spacing } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme, { backgroundColour, headingColour, bodyColour }) => ({
    item: {
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        padding: spacing.small,
        backgroundColor: backgroundColour,
        [theme.breakpoints.up('md')]: {
            flex: '1 0 0',
        },
    },
    header: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: spacing.xs,
    },
    icon: {
        flexShrink: 0,
        width: 32,
        height: 32,
        '& .material-icons': {
            fontSize: 32,
            lineHeight: '32px',
            width: 32,
            height: 32,
            color: headingColour,
        },
    },
    iconImage: {
        flexShrink: 0,
        width: 32,
        height: 32,
        objectFit: 'contain',
        display: 'block',
    },
    question: Object.assign(Object.assign({}, theme.typography.small_bold), { flex: '1 0 0', minWidth: 0, margin: `0 0 ${spacing.xxs} 0`, color: headingColour, wordBreak: 'break-word', [theme.breakpoints.up('md')]: Object.assign(Object.assign(Object.assign({}, theme.typography.medium_bold), (theme.isFlyingFlowers ? {} : { lineHeight: '1.75rem' })), { margin: `0 0 ${spacing.xs} 0` }) }),
    answer: Object.assign(Object.assign({}, theme.typography.small_regular), { color: bodyColour, wordBreak: 'break-word', '& p, & ul li, & ol li': Object.assign(Object.assign({}, theme.typography.small_regular), { color: 'inherit', margin: '0 !important' }), '& p:not(:last-child), & ul:not(:last-child), & ol:not(:last-child)': {
            marginBottom: `${spacing.xs} !important`,
        }, '& a': {
            color: 'inherit',
            textDecoration: 'underline',
            textUnderlinePosition: 'from-font',
        } }),
}));
export default useStyles;
